import { render, staticRenderFns } from "./RoleForm.vue?vue&type=template&id=6adb983e&"
import script from "./RoleForm.vue?vue&type=script&lang=ts&"
export * from "./RoleForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports